function removeCartEntryOption (event, entryIndex, optionCode) {
    event.preventDefault();
    var data = {};
    data["entryIndex"] = entryIndex;
    data["optionCode"] = optionCode;
    postCartData(data,'/remove/cart-entry/option', event);
}

var postCartData = function (data,url,eventLocal){
    var token = $("input[name='_csrf']").val();
    var header = "X-CSRF-TOKEN";
    $.ajax({
        url: url ,
        type: 'POST',
        data: JSON.stringify(data) ,
        beforeSend: function(xhr) {
            xhr.setRequestHeader(header, token);
        },
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
            document.location.reload();
        },
        error: function (jqXHR, textStatus, errorThrown) {
            var response = jqXHR.responseText;
            var upsellingContainer = $(eventLocal.target).closest('.upselling-data-container');
            if (jqXHR.status === 400) {
                resetMessages();
                if (response === ""){
                    engraveEmptyMessage(upsellingContainer);
                } else {
                    engraveErrorMessage(response, upsellingContainer);
                }
            }
        }
    });
};